<p-table
  [value]="rows"
  [scrollable]="true"
  scrollHeight="flex"
  sortField="name"
  [defaultSortOrder]="1"
  [customSort]="true"
  (sortFunction)="customSort($event)"
  class="ngkit-table"
>
  <ng-template pTemplate="header">
    <tr>
      <th class="col-name" pSortableColumn="name">
        <p-sortIcon field="name" />
        Display Name
      </th>
      <th class="col-actions"></th>
      <th class="col-email" pSortableColumn="email">
        <p-sortIcon field="email" />
        Email
      </th>
      <th class="col-type" pSortableColumn="type">
        <p-sortIcon field="type" />
        Type
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row>
    <tr>
      <td data-col="name">
        <span class="name-cell min-width-0">
          @if (rowIcon(row); as icon) {
            <fga-icon
              class="row-icon"
              [name]="icon.name"
              [size]="12"
              [ariaLabel]="icon.ariaLabel"
            />
          }
          <span class="row-name text-truncate min-width-0" [fgaEllipsisTitle]="row.name">{{ row.name }}</span>
        </span>
      </td>
      <td class="col-actions">
        @if (!hideRemove) {
          <p-button
            styleClass="ngkit-button"
            severity="secondary"
            variant="text"
            (click)="removeClicked(row)"
            icon="pi ds-ngkit-delete"
            [pTooltip]="removeTooltip()"
            tooltipPosition="top"
            tooltipEvent="both"
            [ariaLabel]="removeAriaLabel(row)"
          />
        }
      </td>
      <td data-col="email">
        <span class="text-truncate" [fgaEllipsisTitle]="row.email ?? ''">{{ row.email }}</span>
      </td>
      <td data-col="type">
        <span class="type-cell">{{ rowTypeLabel(row) }}</span>
      </td>
    </tr>
  </ng-template>
</p-table>
